import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";

export function SelectAllHeader(props: any) {
    const [rows, setRows] = useRecoilState<any[]>(props.recoilState);
    const { t } = useTranslation(['network', 'translation']);

    const allSelected = rows.length > 0 && rows.every(r => r._select);
    const someSelected = rows.length > 0 && rows.some(r => r._select) && !allSelected;

    const handleToggleAll = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const checked = evt.target.checked;
        const updatedRows = rows.map(r => ({ ...r, _select: checked }));
        setRows(updatedRows);
    };

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%',
            position: 'relative'
        }}>

            <Box
                component="span"
                sx={{
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    fontWeight: 600,

                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',

                    textAlign: 'center',
                    lineHeight: '1.2',
                    maxWidth: 'calc(100% - 50px)'
                }}
            >
                {props.displayName}
            </Box>

            <Tooltip
                title={t("msHoliday.labels.selectAll")}
                arrow
                placement="top"
            >
                <Checkbox
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={handleToggleAll}
                    size="small"
                    color="primary"
                    sx={{ mr: -1 }}
                />
            </Tooltip>
        </Box>
    );
}